angular.
module("dx.webapp.client").
controller("DxDeprecationPopupController", function DeprecationPopupController(
	$scope,

	dxDialog
) {
	"use strict";

	var self = this;
	self.saveEnabled = !!$scope.client.deprecationTime;
	self.removeEnabled = !!$scope.client.deprecationTime;
	self.deprecationTime = new Date($scope.client.deprecationTime);


	self.validateTime = function validateTime(error) {
		self.saveEnabled = !error;
	};

	self.remove = function remove() {
		self.deprecationTime = null;
		self.save();
	};

	self.close = function close() {
		dxDialog.closeMostRecent();
	};

	self.save = function save() {
		$scope.client.deprecationTime = self.deprecationTime;
		$scope.onSave($scope.client); // eslint-disable-line angular/controller-as
	};
});
